
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 10 10","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.083 1.74L8.261.916 5 4.177 1.74.918l-.823.822L4.177 5 .918 8.26l.822.823L5 5.823l3.26 3.26.823-.822L5.823 5z","fill-rule":"evenodd"}})])
          )
        }
      }
    